<template>
  <div id="add-api" class="editor-modal">
    <h2>{{ $t("api-modal.heading") }}</h2>
    <form @submit="onCreate">
      <custom-input
        ref="name"
        :inputType="'text'"
        v-model="apiKey.name"
        :name="'nameInput'"
        :label="$t('api-modal.name')"
        :placeholder="$t('api-modal.placeholder')"
        :isRequired="true"
        :focusInputField="true"
      />
      <p class="text-small text-danger">{{ $t("api-modal.warning") }}</p>
      <div class="footer">
        <button type="submit" class="btn btn-md btn-primary" :disabled="!valid" @click="onCreate" v-bind:loading="true">
          {{ $t("api-modal.create") }}
        </button>
        <button type="reset" class="btn btn-md btn-secondary" @click="$emit('close')">
          {{ $t("api-modal.cancel") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";

export default {
  props: {
    onSave: Function,
    inputPlaceholder: String,
    title: String,
    scopes: Array,
  },
  data() {
    return {
      toScopes: "",
      apiKey: {
        name: "",
        scopes: ["template_generate"],
      },
    };
  },
  computed: {
    valid() {
      return this.apiKey.name && this.apiKey.scopes;
    },
  },
  methods: {
    onCreate(evt) {
      evt.preventDefault();
      this.onSave(this.apiKey);
      this.$emit("close");
      // this.loading = true;
    },
    addScope() {
      this.apiKey.scopes.push(this.toScopes);
    },
  },
  components: {
    CustomInput,
  },
};
</script>

<style lang="less">
#add-api {
  padding: 30px 25px 25px 25px;
  h2 {
    margin-bottom: 0;
  }    
}
</style>
